import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {DataTable} from "./edit/FoodSearch";

export function WebFoodSearch() {
    const [searchParam, setSearchParam] = useState("");
    const [returnLimit, setReturnLimit] = useState(25);
    const [mode, setMode] = useState("search");
    const [currentSearchStr, setCurrentSearchStr] = useState("");
    const location = useLocation();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const param = urlParams.get('searchParam') || "";
        const searchMode = urlParams.get('mode') || "search";
        const lim = urlParams.get('l') || "25";

        setSearchParam(param);
        setMode(searchMode);
        setReturnLimit(parseInt(lim));
        setCurrentSearchStr(param);
    }, [location.search]);

    function validateAndSearch(event: React.MouseEvent | React.FormEvent) {
        if(searchParam?.length !== 0) {
            setCurrentSearchStr(searchParam);
        }
        event.preventDefault();
    }

    return (
        <div>
            <h1>Food Database Search</h1>

            <form style={{
                backgroundColor: '#f5f5f5',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #ccc',
                boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                margin: '20px 0'
            }}>
            <label style={{marginTop: "10px", fontSize: "18px"}} htmlFor="searchParam">Search for:</label>
                <input style={{fontSize: "18px", width: "200px"}} type="text" placeholder="Search for food..."
                       onChange={ e => setSearchParam(e.target.value)}
                       value={searchParam} />

                <label style={{marginTop: "10px", fontSize: "18px"}} htmlFor="returnLimit">Maximum number of results:</label>
                <input style={{fontSize: "18px", width: "200px"}} type="number" placeholder="Maximum results..."
                       value={returnLimit} onChange={e => setReturnLimit(parseInt(e.target.value))}/>

                <label style={{marginTop: "10px", fontSize: "18px"}} htmlFor="searchMode">Type of search:</label>
                <select value={mode} onChange={e => setMode(e.target.value)} id="searchMode"
                        style={{ fontSize: "18px"}}>
                    <option value="search">Search</option>
                    <option value="category">Category</option>
                    <option value="userName">User Name</option>
                </select><br/>
                <button onClick={e => validateAndSearch(e)}>Search &gt;&gt;</button>
            </form>
            <DataTable searchParam={currentSearchStr} mode={mode} limit={returnLimit}/>
        </div>
    );
}
